import { Card as AntdCard, Divider, Flex } from "antd";
import React from "react";

export const CardHeaderToolbar: React.FunctionComponent<React.PropsWithChildren> = (
  props
) => <Flex gap={8}>{props.children}</Flex>;

export const CardHeader: React.FunctionComponent<React.PropsWithChildren> = (props) => {
  return (
    <>
      <Flex gap={8}>{props.children}</Flex>
      <Divider />
    </>
  );
};

export const CardBody: React.FunctionComponent<React.PropsWithChildren> = (props) => (
  <>{props.children}</>
);

export const Card = AntdCard;
